import { call, put, takeLatest, all } from "redux-saga/effects";
import { push } from "react-router-redux";

import { showAlert } from "../../utility/alertHelper";

import {
  LOGIN_ACTION,
  LOGIN_ACTION_SUCCEEDED,
  LOGIN_ACTION_FAILED,
  SIGNUP_ACTION,
  SIGNUP_ACTION_FAILED,
  SIGNUP_ACTION_SUCCEEDED,
  FORGOT_PASSWORD_ACTION,
  FORGOT_PASSWORD_ACTION_SUCCEEDED,
  RESET_PASSWORD_ACTION,
  RESET_PASSWORD_ACTION_SUCCEEDED,
  FORGOT_PASSWORD_ACTION_FAILED,
  RESET_PASSWORD_ACTION_FAILED,
  RESEND_ACTIVATION_ACTION,
  RESEND_ACTIVATION_ACTION_SUCCEEDED,
  RESEND_ACTIVATION_ACTION_FAILED,
  LOGOUT_ACTION,
  LOGOUT_ACTION_FAILED,
  LOGOUT_ACTION_SUCCEEDED,
  GLOBAL_AVAILABLE_CREDITS,
  BLOCKED_CREDITS,
  FETCH_COUNTRIES_REQUEST
} from "../../common/constants";

import * as api from "../../services/login";
import Session from "../../utility/session";
import { resetPasswordHandleChange } from "../../common/actions";
import { fetchCountriesFailure, fetchCountriesSuccess } from "./actions";
// import history from "../../utility/history";
// function* loginSaga() {

//Worker saga
function* login(action) {
  let requestedUrl = window.location.href
  try {
    const loginResult = yield call(api.login, action.loginInfo);

    if (loginResult.success) {
      Session.setItem(Session.CURRENT_USER_NAME, action.loginInfo.username);
      Session.setItem(Session.CURRENT_NAME, loginResult.userInfo.name);
      Session.setItem(Session.CURRENT_USER_ID, loginResult.userInfo.userId);
      Session.setItem(
        Session.MM_CUSTOMER_ID,
        loginResult.userInfo.mmcustomerid
      );

      yield put({
        type: LOGIN_ACTION_SUCCEEDED,
        loginInfo: action.loginInfo
      });
        // setting GLOBAL_AVAILABLE_CREDITS if loging result contains available credits
      if (loginResult.userInfo.available_credits) {
        yield put({
          type: GLOBAL_AVAILABLE_CREDITS,
          available_credits: loginResult.userInfo.available_credits
        })
      }

      if(loginResult.userInfo.blockedcredits) {
        yield put({
          type: BLOCKED_CREDITS,
          blockedcredits: loginResult.userInfo.blockedcredits
        })
      }

      requestedUrl = requestedUrl.split("?").slice(1).join("?")
      let exactPath = new URLSearchParams(requestedUrl).get("next")
      yield put(push(exactPath ? exactPath : "/email-verification"));
    } else {
      if(loginResult.type && loginResult.type == "notVerified"){
        const username = loginResult.username
        showAlert(loginResult.msg)
        // Redirect after 4 secs
        const delay = time => new Promise(resolve => setTimeout(resolve, time));
        yield call(delay, 4000);
        yield put(push({pathname:`/resendactivation`, state:{username}}))
      } else {
        showAlert(loginResult.msg);
        yield put({
          type: LOGIN_ACTION_FAILED,
          args: {
            message: loginResult.msg
          }
        });
      }
    }
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "Login Failed " + error
    });

    yield put({
      type: LOGIN_ACTION_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

// async function signupSync(signupInfo) {
//   await api.signup(signupInfo);
//   console.log("after async call");
// }

function* signup(action) {
  try {
    const result = yield call(api.signup, action.signupInfo);
    if (result.success) {
      // showAlert(result.msg);

      yield put({
        type: SIGNUP_ACTION_SUCCEEDED
      });
      showAlert(result.msg);
      yield put(push("/signup-success"));
    } else {
      yield put({
        type: SIGNUP_ACTION_FAILED,
        args: {
          message: result.msg && result.msg.msg_text ? result.msg.msg_text : (typeof result.msg === "string" ? result.msg : "Error occured in account creation."),
          requireRecaptchaV2: result.requireRecaptchaV2 || false
        }
      });
    }
    //Here logic need to be implemeted to show error msg and success msg by response

    // console.log("after SIGNUP_ACTION_SUCCEEDED call");
    // history.push("/dashboard");
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "Error occured in account creation." + error.message
    });

    yield put({
      type: SIGNUP_ACTION_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker Saga
function* forgotPassword(action) {
  try {
    const result = yield call(api.forgotPassword, action.forgotPasswordInfo);
    if (result.success) {
      showAlert(result.msg);

      yield put({
        type: FORGOT_PASSWORD_ACTION_SUCCEEDED,
        forgotPasswordInfo: result
      });
    } else {
      showAlert(result.msg);
      yield put({
        type: FORGOT_PASSWORD_ACTION_FAILED,
        args: {
          message: result.msg.msg_text || "Error occured in Forgot password . "
        }
      });
    }
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "Error occured in forgot password. " + error.message
    });
    yield put({
      type: FORGOT_PASSWORD_ACTION_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker Saga
function* resendActivation(action) {
  try {
    const result = yield call(
      api.resendActivation,
      action.resendActivationInfo
    );
    if (result.success) {
      showAlert(result.msg);

      yield put({
        type: RESEND_ACTIVATION_ACTION_SUCCEEDED,
        resendActivationInfo: result
      });
    } else {
      showAlert(result.msg);
      yield put({
        type: RESEND_ACTIVATION_ACTION_FAILED,
        args: {
          message:
            result.msg.msg_text || "Error occured in resend Activation . "
        }
      });
    }
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "Error occured in resend Activation. " + error.message
    });
    yield put({
      type: RESEND_ACTIVATION_ACTION_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker Saga

function* resetPassword(action) {
  try {
    const result = yield call(api.resetPassword, action.forgotPasswordInfo);
    if (result.success) {
      showAlert(result.msg);

      yield put({
        type: RESET_PASSWORD_ACTION_SUCCEEDED,
        forgotPasswordInfo: result
      });
    } else {
      showAlert(result.msg);
      yield put({
        type: RESET_PASSWORD_ACTION_FAILED,
        args: {
          message: result.msg || "Error occured in resetting password . "
        }
      });
    }
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "Error occured in resetting password. " + error.message
    });

    yield put({
      type: RESET_PASSWORD_ACTION_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

//Worker Saga
function* logout(action) {
  try {
    
    const result = yield call(api.logout, action.LOGOUT_ACTION);
    if (result.success) {
      showAlert(result.msg);

      yield put({
        type: LOGOUT_ACTION_SUCCEEDED
      });
    } else {
      showAlert(result.msg);
      yield put({
        type: LOGOUT_ACTION_FAILED,
        args: {
          message: result.msg || "Error occured while logout . "
        }
      });
    }
  } catch (error) {
    showAlert({
      msg_code: "",
      msg_type: "error",
      msg_text: "Error occured  while logout. " + error.message
    });

    yield put({
      type: LOGOUT_ACTION_FAILED,
      args: {
        message: error.message
      }
    });
  }
}

// listener Saga
function* onLogin() {
  yield takeLatest(LOGIN_ACTION, login);
}

//listener saga for signup

function* onSignup() {
  yield takeLatest(SIGNUP_ACTION, signup);
}

function* onForgotPassword() {
  yield takeLatest(FORGOT_PASSWORD_ACTION, forgotPassword);
}

function* onResendActivation() {
  yield takeLatest(RESEND_ACTIVATION_ACTION, resendActivation);
}

function* onResetPassword() {
  yield takeLatest(RESET_PASSWORD_ACTION, resetPassword);
}

function* onLogout() {
  
  yield takeLatest(LOGOUT_ACTION, logout);
}


function* fetchCountries() {
  try {
    const response = yield call(api.getCountryList);
    yield put(fetchCountriesSuccess(response.data));
  } catch (error) {
    yield put(fetchCountriesFailure(error.message));
  }
}

export function* watchFetchCountries() {
  yield takeLatest(FETCH_COUNTRIES_REQUEST, fetchCountries);
}

//saga composition
//yield[call(onLogin)];
//}

export default function* loginSaga() {
  yield [
    onLogin(),
    onSignup(),
    onForgotPassword(),
    onResetPassword(),
    onResendActivation(),
    onLogout(),
    watchFetchCountries()
  ];
}



// WEBPACK FOOTER //
// ./src/Containers/Login/sagas.js